import { getInitialState, getPath } from "../../utils";

const initialState = {
  slotsList: [],
  activeSlot: {},
  activeFilters: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_SLOTS_LIST":
      return setSlotsList(state, action);
    case "SET_ACTIVE_SLOT":
      return setActiveSlot(state, action);
    case "SET_ACTIVE_FILTERS_SLOTS":
      return setActiveFiltersSlots(state, action);
    case "RESET_STATE_SLOT":
      return resetStateSlot(state, action);
    default:
      return state;
  }
}

const setSlotsList = (state, action) => {
  return {
    ...state,
    slotsList: getPath(action.payload, "data", []),
  };
};

const resetStateSlot = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActiveSlot = (state, action) => {
  return {
    ...state,
    activeSlot: getPath(action.payload, "data", {}),
  };
};

const setActiveFiltersSlots = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
